import type { Release } from '../releases.ts';

export default {
  version: '0.18.2',
  date: '2026-10-02',
  title: 'Live source keys',
  summary: [
    'New stream keys and SRT passphrases use letters and digits only, so no app changes them when pasted',
    'Make a new key while the source is stopped to get one',
  ],
  features: [],
  fixes: ['New stream keys and SRT passphrases are letters and digits only, so no app can change them when they are pasted (make a new key, while the source is stopped, to get one)'],
} satisfies Release;
